
import { useExtendWithSubnetworks } from "@l2r-front/l2r-networks"

import { API_MODULE_ROADWAY } from "../../../../../common/constants/appRoad"
import { useRoadQuery } from "../../../../../common/hooks/queries/useRoadQuery"

import { networkGradingsQueryKeys } from "./queryKeys"

export function useNetworkGrading(selectedNetworkYearlyStatus, queryParameters, config = {}) {
    const parameters = useExtendWithSubnetworks({
        ...queryParameters,
        year: selectedNetworkYearlyStatus?.year,
        as_geojson: true,
    }, API_MODULE_ROADWAY)
    const { enabled = !!selectedNetworkYearlyStatus?.year } = config
    const queryKey = networkGradingsQueryKeys.list(parameters)
    const url = "segment_gradings/"

    return useRoadQuery(
        url,
        queryKey,
        parameters,
        {
            ...config,
            enabled: enabled,
        },
    )
}
